import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";

/**
 * A titled, scrollable, color-toned list of URLs. Shared by the discover-test
 * dialog and the discover-item panel so both present found URLs identically.
 */
export function UrlList({
  title,
  urls,
  tone,
}: {
  title: string;
  urls: string[];
  tone: "new" | "known" | "all";
}) {
  const color =
    tone === "new"
      ? "text-emerald-700 dark:text-emerald-300"
      : tone === "known"
        ? "text-muted-foreground"
        : "text-foreground";
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium">{title}</span>
        <Badge variant="secondary">{urls.length}</Badge>
      </div>
      <ScrollArea className="h-40 rounded-md border p-2">
        {urls.length === 0 ? (
          <p className="text-xs text-muted-foreground">None</p>
        ) : (
          <ul className={`space-y-1 text-xs ${color}`}>
            {urls.map((url) => (
              <li key={url} className="truncate font-mono" title={url}>
                {url}
              </li>
            ))}
          </ul>
        )}
      </ScrollArea>
    </div>
  );
}
